import { Row } from 'react-grid-system'
import styled from 'styled-components'

export const AddPaymentFormRow = styled(Row)`
  margin-top: 20px;;
  margin-bottom: 40px;
`

export const AddPaymentFormGroup = styled.div`
  margin: 15px 0px;
`

export const AddPaymentFormFieldset = styled.fieldset`
    border-radius: 8px;
    padding: 0px 5px 5px 5px;
    min-height: 48px;
    border: 1px solid #f0eff0;
    margin: 8px 0px;
`